import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ReactApexChart from "react-apexcharts";

const calcularTamañoHollow = (DataRangos, genero, Igc) => {
    const generoKey = genero === 'M' ? 'hombre' : 'mujer';

    for (const rango of DataRangos) {
        const parametros = JSON.parse(rango.parametros);

        // Verifica si el rango es para el género actual
        if (parametros && parametros[generoKey]) {
            const [min, max] = parametros[generoKey].split('-').map(Number);

            // Comprueba si Igc está dentro del rango
            if (Igc >= min && Igc <= max) {
                const label = rango.valor;
                return {
                    label,
                };
            }
        }
    }

    return {
        label: '',
    };
};
const calcularRangoOptimo = (genero) => {
    if (genero === "F") {
        return [21, 33];
    } else if (genero === "M") {
        return [11, 22];
    }
    return [45, 59]; // Rango predeterminado si no coincide con las condiciones anteriores
};

const LineChartIGC = ({ data, DataRangos, genero }) => {
    const [Rango, setRango] = useState("");
    const [rangoY, rangoY2] = calcularRangoOptimo(genero);
    // Extrae los valores de IGC y las fechas correspondientes desde los datos
   
    const lastTenData = data.slice(-5).reverse();  // Invertir el orden de los datos
    const igcValues = lastTenData.map((record) => record.igc );
    // Meses correspondientes a los puntos en el eje X
    const months = lastTenData.map((record) => {
        const date = new Date(record.datecreate);
        const day = date.getDate();
        const monthNames = [
            "ene", "feb", "mar", "abr", "may", "jun",
            "jul", "ago", "sep", "oct", "nov", "dic"
        ];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    });

    // Configuración de la gráfica
    const options = {
        chart: {
            id: "line-chart",
            width: "80%",
        },
        xaxis: {
            categories: months, // Usamos los meses como categorías
        },
        yaxis: {
            min: 0, // Establece el valor mínimo en el eje Y
            max: 60, // Establece el valor máximo en el eje Y
            tickAmount: 4, // Establece la cantidad de valores en el eje Y
            labels: {
                colors: ["#005aa9"], // Establece el color de los valores en el eje Y
                formatter: function (value) {
                    return Math.round(value);
                },
            },
        },
        fill: {
            type: "gradient",
            gradient: {
                type: "vertical",
                shadeIntensity: 0.2,
                opacityFrom: 0.7,
                opacityTo: 0.7,
                stops: [0, 100],
            },
        },
        stroke: {
            width: 3,
            colors: ["#005aa9"], // Color de la línea aquí
            opacity: 3,
        },
        markers: {
            size: 4,
            colors: '#005aa9', // Color de los puntos (en este caso, el color de peso)
        },
        annotations: {
            yaxis: [
                {
                    y: rangoY,
                    y2: rangoY2,
                    fillColor: "#005aa9", // Color del sombreado del rango óptimo
                    opacity: 0.2,
                },
            ],
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const month = months[dataPointIndex]; // Mes correspondiente al punto
                const igcValue = series[0][dataPointIndex]; // Valor de IGC
                const formattedIgc = Number(igcValue) % 1 === 0 ? Number(igcValue) : Number(igcValue).toFixed(2);

                const { label } = calcularTamañoHollow(DataRangos, genero, igcValue);

                return (
                    '<div class="custom-tooltip" style="height:50px; width:120px;font-size:12px;border-radius:10%;">' +
                    '<div class="tooltip-title" style="background-color: ' +
                    w.globals.stroke.colors[seriesIndex] +
                    '; color: white; padding-left: 10px; opacity:1">' +
                    month + // Mes en el título
                    '</div>' +
                    '<div class="tooltip-content" style="height: 60px;padding-top: 5px; ">' +
                    '<div class="sales-circle" style="background-color: ' +
                    w.globals.stroke.colors[seriesIndex] +
                    '; border-radius: 50%; width: 10px; height: 10px; display: inline-block; margin-right: 5px;margin-left: 10px; "></div>' +
                    '<span class="sales-text" style="font-weight: bold; margin: 0;">' + formattedIgc  + ": " + label +
                    '</span>' +
                    '</div>' +
                    '</div>'
                );
            },
        },
    };


    return (
        <div>
            <div>
                <ReactApexChart options={options} series={[{ name: "IGC", data: igcValues }]} type="line" height={200} />
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "-5%", marginLeft: "-30%", marginBottom: "6%" }}>
                <div style={{ marginRight: "20px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                width: "10px",
                                height: "3px",
                                backgroundColor: "#005aa9",
                                marginRight: "5px",
                            }}
                        ></div>
                        IGC
                    </div>
                </div>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                width: "10px",
                                height: "10px",
                                backgroundColor: "#005aa9",
                                opacity: 0.2,
                                marginRight: "5px",
                            }}
                        ></div>
                        Rango Óptimo
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LineChartIGC;
